import { render, staticRenderFns } from "./view-dialog.vue?vue&type=template&id=4668a36e&"
import script from "./view-dialog.vue?vue&type=script&lang=js&"
export * from "./view-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports